<template>
  <section class="hero-section">
    <div class="hero-bg">
      <!-- PC端视频背景 -->
      <video
        class="hero-bg__video"
        :src="require('@/assets/video/homevideo.mp4')"
        autoplay
        muted
        loop
        playsinline
      ></video>
      <!-- 移动端图片背景 -->
      <!-- <picture>
        <source :srcset="bgImageMobile" media="(max-width: 767px)" />
        <img :src="bgImage" alt="" class="hero-bg__img" />
      </picture> -->
      <picture class="hero-bg__picture-mobile">
        <source :srcset="bgImageMobile" media="(max-width: 767px)" />
        <img :src="bgImage" alt="" class="hero-bg__img" />
      </picture>
      <div class="hero-bg__overlay"></div>
    </div>

    <div class="hero-content">
      <span class="hero-eyebrow">{{ data.eyebrow }}</span>
      <h1 class="hero-title" v-html="data.title"></h1>
      <p class="hero-subtitle" v-if="data.subTitle">{{ data.subTitle }}</p>
      <p class="hero-copy">{{ data.copy }}</p>
      <div class="hero-cta">
        <a
          class="hero-cta__btn hero-cta__btn--primary"
          :href="data.primaryLink"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ data.primaryText }}
        </a>
        <a
          class="hero-cta__btn hero-cta__btn--secondary"
          :href="data.secondaryLink"
        >
          {{ data.secondaryText }}
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HeroSection",
  props: {
    data: {
      type: Object,
      required: true,
    },
    bgImage: {
      type: String,
      default: require("@/assets/images/homepage_hero_city_lake.jpg"),
    },
    bgImageMobile: {
      type: String,
      default: require("@/assets/images/homepage_hero_city_lake_mobile.jpg"),
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.hero-section {
  position: relative;
  width: 100%;
  overflow: hidden;

  &::before {
    content: "";
    display: block;
    // padding-top: 72.222%; // 1040 / 1440
    padding-bottom: 62.22%;
    // padding-top: 62.222%; // 1040 / 1440
  }
}

.hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  &__img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    display: block;
  }

  &__video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    display: block;
  }

  &__picture-mobile {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // 设计稿 rotation 200 = 渐变从200°方向出发(左下)，CSS 角度 = 200 - 180 = 20deg   78% 78% at 18% 100%,
    background: linear-gradient(
        0deg,
        rgba(25, 70, 112, 1) 1%,
        rgba(25, 70, 112, 0) 23%
      ),
      radial-gradient(
        ellipse 78% 36% at 33% 120%,
        rgba(23, 106, 153, 0.671) 0%,
        rgba(23, 106, 153, 0) 100%
      ),
      linear-gradient(
        120deg,
        rgba(0, 60, 125, 0.502) 0%,
        rgba(10, 31, 53, 0.051) 42%,
        rgba(10, 31, 53, 0) 100%
      );
  }
}

.hero-content {
  position: absolute;
  top: 13.65%; // 142 / 1040 (heroLeftV3 frame y)
  left: 2.78%; // 40 / 1440 (heroLeftV3 frame x)
  width: 52.85%; // 761 / 1440 (heroLeftV3 frame width)
  padding: 6.94% 1.67% 0 1.67%; // [100, 24, 0, 24] → padding % 基于 containing block 宽度(1440)
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  box-sizing: border-box;
}

.hero-eyebrow {
  font-family: $font-family;
  font-size: 12px;
  font-weight: normal;
  color: #e8d8b3;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  margin-bottom: 24px;
}

.hero-title {
  font-family: $font-family;
  font-size: 81px;
  font-weight: 700;
  color: #ffffff;
  line-height: 0.96;
  margin: 0 0 24px 0;
  text-align: left;
  text-shadow: 0 4px 4px rgba(23, 106, 153, 0.3);
}

.hero-subtitle {
  font-family: $font-family;
  font-size: 26px;
  font-weight: 700;
  color: #ffffff;
  line-height: 0.96;
  margin: 0 0 58px 0; // 设计稿 subtitle 到 copy 间距 58px (含 10px spacer)
  text-shadow: 0 4px 4px rgba(23, 106, 153, 0.3);
}

.hero-copy {
  font-family: $font-family;
  font-size: 17px;
  font-weight: normal;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.72;
  margin: 0 0 24px 0;
  text-shadow: 0 4px 4px rgba(23, 106, 153, 0.3);
  text-align: left;
}

.hero-cta {
  display: flex;
  gap: 14px;

  &__btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 18px 24px;
    font-family: $font-family;
    text-decoration: none;
    cursor: pointer;
    transition: opacity 0.2s;
    border-radius: 16px;

    &--primary {
      background-color: #d6b06b;
      color: #132d4a;
      font-size: 15px;
      font-weight: 600;
      border: none;

      &:hover {
        opacity: 0.9;
      }
    }

    &--secondary {
      background-color: rgba(0, 0, 0, 0.05);
      color: #ffffff;
      font-size: 15px;
      font-weight: normal;
      border: 1px solid rgba(255, 255, 255, 0.5);

      &:hover {
        background-color: rgba(255, 255, 255, 0.08);
      }
    }
  }
}

// xl 中等屏幕适配 (1200-1399px)
@media (max-width: 1399px) and (min-width: 1200px) {
  .hero-eyebrow {
    margin-bottom: 20px;
  }

  .hero-title {
    font-size: 68px;
    margin-bottom: 20px;
  }

  .hero-subtitle {
    font-size: 22px;
    margin-bottom: 48px;
  }

  .hero-copy {
    font-size: 16px;
    margin-bottom: 20px;
  }

  .hero-cta__btn {
    padding: 16px 22px;
    font-size: 14px;
  }
}

// lg 平板适配 (992-1199px)
@media (max-width: 1199px) and (min-width: 992px) {
  .hero-eyebrow {
    font-size: 11px;
    margin-bottom: 18px;
  }

  .hero-title {
    font-size: 52px;
    margin-bottom: 18px;
  }

  .hero-subtitle {
    font-size: 18px;
    margin-bottom: 40px;
  }

  .hero-copy {
    font-size: 15px;
    margin-bottom: 18px;
  }

  .hero-cta__btn {
    padding: 14px 20px;
    font-size: 14px;
  }
}

// md 小屏电脑适配 (768-991px)
@media (max-width: 991px) and (min-width: 768px) {
  .hero-eyebrow {
    font-size: 10px;
    margin-bottom: 16px;
  }

  .hero-title {
    font-size: 40px;
    margin-bottom: 16px;
  }

  .hero-subtitle {
    font-size: 16px;
    margin-bottom: 32px;
  }

  .hero-copy {
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 16px;
  }

  .hero-cta__btn {
    padding: 12px 18px;
    font-size: 13px;
  }
}

// xs 手机适配 (≤767px)
@media (max-width: 767px) {
  .hero-bg__video {
    display: none;
  }

  .hero-bg__picture-mobile {
    display: flex;

    .hero-bg__img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .hero-section::before {
    padding-top: 148.717%; // 580 / 390
  }

  .hero-content {
    top: auto;
    bottom: 8%;
    left: 0;
    width: 100%;
    padding: 0 20px;
    gap: 14px;
    justify-content: flex-end;
  }

  .hero-eyebrow {
    font-size: 11px;
    margin-bottom: 14px;
  }

  .hero-title {
    font-size: 36px;
    line-height: 1.2;
    margin-bottom: 14px;
  }

  .hero-subtitle {
    font-size: 15px;
    line-height: 1.3;
    margin-bottom: 24px;
  }

  .hero-copy {
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 14px;
  }

  .hero-cta {
    gap: 14px;

    &__btn {
      font-size: 14px;
      padding: 15px;
    }
  }
}
</style>
